import styled from 'styled-components';

export const SpotlightsSection = styled.section`
  .industries {
    list-style: none;
    padding: 0;
    margin: 0 0 30px;
    text-align: center;
    li {
      display: inline-block;
      margin: 0 15px 20px;
      font-weight: 400;
      font-size: 0.9375rem;
      button.link-style {
        background: none;
        padding: 0;
        border: none;
        cursor: pointer;
        color: ${props => props.theme.gray800};
        &:hover {
          color: ${props => props.theme.primary};
        }
      }
      &.active {
        button.link-style {
          color: ${props => props.theme.primary};
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }
  }
`;
